import { WxShape } from './shape/wx-shape';
import { WxEnvelope } from './shape/wx-envelope';
import { WxRectangle } from './shape/wx-rectangle';
import { WxArc } from './shape/wx-arc';
import { WxText } from './shape/wx-text';
import { ArrayUtils } from '@shared/util/array-utils';
import { WxDrawingElementVO } from '@article/model/vo/wx-article.vo';
import { NumberUtils } from '@shared/util/number-utils';

export class WxDrawingElement {
  public constraint: boolean;
  public coordinateX: number;
  public coordinateY: number;
  public coordinateZ: number;
  public drawing: boolean;
  public drawingID: number;
  public elementOrder: number;
  public lineWidth: number;
  public mirror: boolean;
  public mirrorX: number;
  public mirrorY: number;
  public mirrorZ: number;
  public open: boolean;
  public rgb1: number;
  public rotationX: number;
  public rotationY: number;
  public rotationZ: number;
  public texture: string;
  public elements: WxShape[] = [];

  public constructor(element: WxDrawingElementVO) {
    this.constraint = element.constraint;
    this.coordinateX = element.coordinateX;
    this.coordinateY = element.coordinateY;
    this.coordinateZ = element.coordinateZ;
    this.drawing = element.drawing;
    this.drawingID = element.drawingId;
    this.elementOrder = element.elementOrder;
    this.lineWidth = element.lineWidth;
    this.mirror = element.mirror;
    this.mirrorX = element.mirrorX;
    this.mirrorY = element.mirrorY;
    this.mirrorZ = element.mirrorZ;
    this.open = element.open;
    this.rgb1 = NumberUtils.isNumber(element.rgb1) ? element.rgb1 : 0xffffff;
    this.rotationX = element.rotationX;
    this.rotationY = element.rotationY;
    this.rotationZ = element.rotationZ;
    this.texture = element.texture;

    if (ArrayUtils.isNotEmpty(element.envelopes)) {
      for (const envelope of element.envelopes) {
        this.elements.push(new WxEnvelope(envelope));
      }
    }

    if (ArrayUtils.isNotEmpty(element.rectangles)) {
      for (const rectangle of element.rectangles) {
        this.elements.push(new WxRectangle(rectangle));
      }
    }

    if (ArrayUtils.isNotEmpty(element.arcs)) {
      for (const arc of element.arcs) {
        this.elements.push(new WxArc(arc));
      }
    }

    if (ArrayUtils.isNotEmpty(element.texts)) {
      for (const text of element.texts) {
        this.elements.push(new WxText(text));
      }
    }
  }
}
